// extracted by mini-css-extract-plugin
module.exports = {"pop":"MsgBtn_pop__12fmM"};